import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Redirect
} from "react-router-dom";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import "./components/controlplane/ArtemyStyles.css";
import { Auth } from "aws-amplify";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";


import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
// import firebase from 'firebase/compat/app';
import ActivityTracker from "./components/ActivityTracker";
import { logout } from "./components/action/auth";
import PropTypes from "prop-types";
import { useAuthToken } from "./TokenContext";
import AutoLogout from "./components/AutoLogout";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import ControlPlaneRoutes from "./routes/ControlPlaneRoutes";
import PodRoutes from "./routes/PodRoutes";
import AuthRoutes from "./routes/AuthRoutes";
import ControlPlaneLayout from "./components/controlplane/ControlPlaneLayout";
import CandidateHomeContent from "./components/CandidateHomeContent";
import ArtemySplashScreen from "./components/ArtemySplashScreen";
const stripePromise = loadStripe(process.env.REACT_APP_STRIPEKEY);

library.add(faEdit);

const App = ({ changeLocale, currentLocale }) => {
  const [redirectToLogin, setRedirectToLogin] = useState(false);
  const dispatch = useDispatch();
  const token = useAuthToken();
  const [expanded, setExpanded] = useState(false);



  useEffect(() => {
    const handleResize = () => {
      // Always expanded when the screen width is between 320px and 1080px
      const isMediaWidth =
        window.innerWidth >= 320 && window.innerWidth <= 1080;
      setExpanded(isMediaWidth);
    };

    // Add resize event listener
    window.addEventListener("resize", handleResize);

    // Initial check when the component mounts
    handleResize();

    // Remove event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const { isLoggedIn, user } = useSelector((state) => state.auth);
  const isUserLoggedIn = isLoggedIn === true;

  const [state, setState] = useState({
    isAuthenticated: false,
    isAuthenticating: true,
    user: null,
  });



  const setAuthStatus = (authenticated) => {
    setState({ isAuthenticated: authenticated });
  };

  const setUser = (user) => {
    setState({ user: user });
  };


  // Modify the useEffect for logout in App.js
  useEffect(() => {
    const onInactive = () => {
      // Log out the user
      dispatch(logout());

      // Set redirectToLogin to true to trigger navigation
      setRedirectToLogin(true);
    };

    const activityTracker = new ActivityTracker(60 * 60 * 1000, onInactive); // 1 hour timeout

    return () => {
      window.removeEventListener("mousemove", activityTracker.resetTimer);
      window.removeEventListener("keydown", activityTracker.resetTimer);
    };
  }, [dispatch]);

  // Add a safety check function to use throughout your routes
  const isUserAuthenticated = () => {
    return isUserLoggedIn && user && user.data && user.data.length > 0;
  };
  // ✅ CORRECT: Define async function inside useEffect
  useEffect(() => {
    const checkAuth = async () => {
      try {
        const session = await Auth.currentSession();
        if (session) {
          setAuthStatus(true);
          const user = await Auth.currentAuthenticatedUser();
          setUser(user);
        }
      } catch (error) {
        console.error('Auth error:', error);
      } finally {
        setState({ isAuthenticating: false });
      }
    };

    checkAuth();
  }, []);
  const authProps = {
    isAuthenticated: isLoggedIn,
    user: state.user,
    setAuthStatus: setAuthStatus,
    setUser: setUser,
  };


  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };


  const [collapsed] = useState(true);




  // useEffect(() => {

  //   if (user && user.data && user.data.length > 0) {

  //   const body = {
  //     client_code: user?.data[0]?.type === 'Candidate'
  //       ? user?.data[0]?.talent_code
  //       : user?.data[0]?.client_code
  //   };

  //   const headers = {
  //     'Authorization' : token, // Replace with your actual token
  //     'Content-Type': 'application/json', // You can add more headers as needed
  //   };
  // // Check if the client code contains "PARTNER"
  // if (user.data[0]?.type !== 'Candidate') {
  //   if (user.data[0].client_code.includes("PARTNER")) {
  //     // Second API call
  //     axios.post(process.env.REACT_APP_PARTNER_FTECHSUBSCCRIPTIONPARTNER, body, { headers: headers })
  //       .then((res) => {
  //         // Process the response as needed for the second API
  //         setSubscription(res?.data?.data);
  //         setSubscriptionfetch(res?.data?.data[0]?.priceID);
  //         setloading(false);
  //       })
  //       .catch((err) => {
  //         console.log("Error in the second API call:", err);
  //         setloading(false);
  //       });
  //   } else {
  //     // First API call
  //     axios.post(process.env.REACT_APP_FETCHSUBSCRIPTIONDATA, body, { headers: headers })
  //       .then((res) => {
  //         // Process the response as needed for the first API
  //         setSubscription(res?.data?.data);
  //         setSubscriptionfetch(res?.data?.data[0]?.priceID || null);
  //         setloading(false);
  //       })
  //       .catch((err) => {
  //         console.log("Error in the first API call:", err);
  //         setloading(false);
  //       });
  //   }
  // }}
  // }, [token]);

  // useEffect(() => {
  //   if (user && user.data && user.data.length > 0) {

  //     const body = {
  //       client_code: user.data[0].talent_code,
  //     };

  //     const headers = {
  //       Authorization: token, // Replace with your actual token
  //       'Content-Type': 'application/json', // You can add more headers as needed
  //     };

  //     axios
  //       .post(process.env.REACT_APP_FETCHSUBSCRIPTIONDATA, body, { headers })
  //       .then((res) => {
  //         console.log('response',res)
  //         setSubscription(res.data.data);
  //         setSubscriptionfetch(res.data.data[0]?.priceID );
  //       })
  //       .catch((err) => {
  //         console.log('catch', err);
  //       })
  //       .finally(() => {
  //         setLoading(false); // Set loading to false once the API call is completed.
  //       });
  //   }
  // }, [token, user]);

  // First, let's modify the useEffect hook that fetches subscription data

  // Example usage with error handling:

  return (
    <Container className="app-container">
      {state.isAuthenticating ? (
        <ArtemySplashScreen />
      ) : (
        <Elements stripe={stripePromise}>
          <Router>
            <AutoLogout />
            <MainContentArea isArtemy={window.location.pathname.startsWith('/control-plane') ||
              window.location.pathname.includes('dashboard') ||
              window.location.pathname.includes('profile') ||
              window.location.pathname.includes('Pod') ||
              window.location.pathname.includes('Find') ||
              window.location.pathname.includes('Ai') ||
              window.location.pathname.includes('kanban') ||
              window.location.pathname.includes('meeting') ||
              window.location.pathname.includes('Review')}>
              {redirectToLogin && <Redirect to={{ pathname: "/login" }} />}
              <Route
                exact
                path="/"
                render={() => {
                  if (!isUserAuthenticated()) {
                    return <CandidateHomeContent collapsed={collapsed} />;
                  }
                  return (
                    <ControlPlaneLayout collapsed={collapsed} currentLocale={currentLocale} changeLocale={changeLocale}>
                      <CandidateHomeContent collapsed={collapsed} />
                    </ControlPlaneLayout>
                  );
                }}
              />
              <ControlPlaneRoutes
                isUserAuthenticated={isUserAuthenticated}
                user={user}
                currentLocale={currentLocale}
                changeLocale={changeLocale}
                collapsed={collapsed}
              />
              <AuthRoutes
                isUserAuthenticated={isUserAuthenticated}
                authProps={authProps}
              />
              <PodRoutes
                isUserAuthenticated={isUserAuthenticated}
                user={user}
                authProps={authProps}
                collapsed={collapsed}
                expanded={expanded}
                isLoggedIn={isLoggedIn}
                currentLocale={currentLocale}
                changeLocale={changeLocale}
              />
              {/* <Route
              exact
              path="/PartnerSubscription"
              render={(props) => {
                return isUserAuthenticated() ? (
                  <SubscriptionNew />
                ) : (
                  <Redirect
                    to={{
                      pathname: "/login",
                    }}
                  />
                );
              }}
            /> */}
              {/* <Route exact path="/manage-profile" render={(props) =>{

return  isUserAuthenticated() && user.data[0].type === "Candidate" ? (
<Updateprofile                    
/>):(

<Redirect to={{
pathname: '/login',
}}
/>                                
)
}

} /> */}
              {/* <Route exact path="/TechStackDevloper" render={(props) => <TechStackDevloper {...props} auth={authProps} />} /> */}
              {/* <Route exact path="/Confirm" render={(props) => <Confirm {...props} auth={authProps} />} /> */}
              {/* <Route exact path="/PostedProReq" render={(props) => <PostedProReq {...props} auth={authProps} />} /> */}
              {/* <Route exact path="/EditPostRequirementCand/:id" render={(props) => <EditPostRequirementCand {...props} auth={authProps} />} /> */}
              {/* <Route exact path="/FindPodsCan" render={(props) => <FindPodsCan {...props} auth={authProps} />} />
<Route exact path="/FindPodsCan" render={(props) => <FindPodsCan {...props} auth={authProps} />} /> */}
              {/* <Route exact path="/ReviewsandratingPodcandidate" render={(props) => <ReviewsandratingPodcandidate {...props} auth={authProps} />} /> */}


              <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                pauseOnHover
              />


              {/* NEW CODE */}
              {/* <Route exact path="/ReviewsandratingClient" render={(props) => <ReviewsandratingClient {...props} auth={authProps} />} /> */}
              {/* <Route exact path="/ViewPostedProReq" render={(props) => <ViewPostedProReq {...props} auth={authProps} />} /> */}
              {/* <Route exact path="/Reviewsandratingcandidate" render={(props) => <Reviewsandratingcandidate {...props} auth={authProps} />} /> */}

              {/* <Route exact path="/ManagePod" render={(props) => <ManagePod {...props} auth={authProps} />} /> */}
              {/* <Route exact path="/FindPodsDetails/:id" render={(props) => <FindPodsDetails {...props} auth={authProps} />} /> */}

              {/* <Route exact path="/FindPodDetailsClient/:id" render={(props) => <FindPodDetailsClient {...props} auth={authProps} />} /> */}
              {/* <Route exact path="/FindPods" render={(props) => <FindPods {...props} auth={authProps} />} /> */}

              {/* <Route exact path="/FindPodsClient" render={(props) => <FindPodsClient {...props} auth={authProps} />} /> */}
              {/* <Route exact path="/EditPostRequirementCand/:id" render={(props) => <EditPostRequirementCand {...props} auth={authProps} />} /> */}






              {/* <Route exact path="/subscriptions" render={(props) => {
              return  isUserAuthenticated() && user.data[0].type === "ClientAdmin" ? (

                user.data[0].isApproved === "Approved" ? (  <Subscription {...props} auth={authProps} />   ) : (
                  <ProfileSuccessScreen />
                )):(

                <Redirect to={{
                  pathname: '/login',
                  }}
                  />  
              )
                
              }}  /> */}


              {/* <Route exact path="/candidatebyid/:id" render={(props) => <Candidatedetailsbyid {...props} auth={authProps} />} /> */}
              {/* <Route exact path="/client-createpod" render={(props) => <Clientcreatepod {...props} auth={authProps} />} />
             */}
              {/* navigating to manage pods of partner,client and talents  */}


            </MainContentArea></Router>

        </Elements>
      )}
    </Container>
  );
};

App.propTypes = {
  changeLocale: PropTypes.func.isRequired,
  currentLocale: PropTypes.string.isRequired,
};

export default App;
const MainContentArea = styled.div`
  margin-top: ${props => props.isArtemy ? '0' : '64px'};
  background-color: #08090d;
  color: #e8ecf4;
  // width: 100%;
  height: ${props => props.isArtemy ? '100vh' : 'calc(100vh - 64px)'};
  overflow-y: auto;
   &::-webkit-scrollbar {
    display: none;
  }
  
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
`;
const Container = styled.div`
  display: flex;
  height: 100vh;
  background-color: #08090d;
  color: #e8ecf4;
   &::-webkit-scrollbar {
    display: none;
  }
  
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
  width: 100%;
  flex-direction: row;
  //border-radius:2rem;
  @media screen and (min-width: 320px) and (max-width: 1080px) {
    display: inline;
    flex-direction: column;
  }
`;


